export { default, getServerSideProps } from '@/entries/ServiceProvider';
